import React from 'react';
import { Result, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import SuccessIcon from './SuccessIcon';

const LastSectionCompletionModal = () => {
  const { t } = useTranslation('modal');

  return (
    <Result
      style={{ height: '130px', padding: 0 }}
      icon={
        <Flex justify="center">
          <SuccessIcon />
        </Flex>
      }
      status="success"
      title={t('last_section_completion.title')}
    />
  );
};

export default LastSectionCompletionModal;
